import { useState } from 'react';
import Drawer from '../controls/Drawer';
import type { NavItem } from '../models/LayoutTypes';
import NavList from '../controls/NavList';

interface HeaderProps {
  primaryNav: NavItem[];
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ primaryNav, onLogout }) => {
  const [navOpen, setNavOpen] = useState(false);
  const [subnavOpen, setSubnavOpen] = useState(false);

  function Hamburger(): React.JSX.Element {
    return (
      <svg
        aria-hidden="true"
        viewBox="0 0 20 20"
        className="h-5 w-5 fill-none stroke-current"
      >
        <path d="M3 5h14M3 10h14M3 15h14" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <>
      <header className="sticky top-0 z-50 border-b bg-white/80 backdrop-blur">
        <div className="mx-auto max-w-7xl px-4">
          <div className="flex h-16 items-center justify-between gap-3">
            {/* Left section: brand + mobile toggles */}
            <div className="flex items-center gap-2">
              {/* Mobile: open primary nav */}
              <button
                type="button"
                onClick={() => setNavOpen(true)}
                className="btn lg:hidden"
                aria-label="Open navigation"
                aria-controls="primary-nav-drawer"
                aria-expanded={navOpen}
              >
                <Hamburger />
                <span className="sr-only">Open navigation</span>
              </button>

              {/* Mobile: open sub nav */}
              <button
                type="button"
                onClick={() => setSubnavOpen(true)}
                className="btn lg:hidden"
                aria-label="Open sub-navigation"
                aria-controls="subnav-drawer"
                aria-expanded={subnavOpen}
              >
                <Hamburger />
                <span className="sr-only">Open sub-navigation</span>
              </button>

              {/* Brand */}
              <a href="#" className="inline-flex items-center gap-2">
                <div className="h-7 w-7 rounded-xl bg-slate-900"></div>
                <span className="text-base font-semibold tracking-tight">
                  Proprio Data Admin Portal
                </span>
              </a>
            </div>

            {/* Right section: quick actions */}
            <div className="flex items-center gap-2">
              <button className="btn" onClick={onLogout}>Sign Out</button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile drawers */}
      <Drawer
        id="primary-nav-drawer"
        open={navOpen}
        onClose={() => setNavOpen(false)}
        title="Navigation"
      >
        <NavList items={primaryNav} />
      </Drawer>

      <Drawer
        id="subnav-drawer"
        open={subnavOpen}
        onClose={() => setSubnavOpen(false)}
        title="Sub-navigation"
      >
        <>
        </>
      </Drawer>
    </>

  );
};
export default Header;
